import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import axios from "axios";
import lodash from "lodash";
import DigiFormItem from "../DigiForm/DigiFormItem";

class ChemicalRecordForm extends React.Component {
  state = {
    loading: false,
    done: false,
    fieldErrors: {},
    formFields: this.props.formFields,
    selectedLocation: {},
    poolsForSelectedLocation: {},
    selectedPool: {},
    submitAnother: false,
  };

  componentDidMount() {
    window.addEventListener("online", function (event) {
      toastr.info("You are online now");
    });

    window.addEventListener("offline", function (event) {
      toastr.info("You are offline");
    });
    this.setState({
      selectedLocation: this.props.locationsWithPools[this.props.locationId],
      selectedPool:
        this.props.locationsWithPools[this.props.locationId].pools[
          this.props.poolId
        ],
    });
  }

  render() {
    const { loading, fieldErrors, formFields } = this.state;

    return (
      <div>
        <form onSubmit={this.submit}>
          <DigiFormItem
            key="location_id"
            formFieldKey="location_id"
            formField={{
              type: "select",
              label: "Location",
              required: false,
              value: this.state.selectedLocation.id || this.props.locationId,
              select_options: this.props.locationOptions,
              enabled: this.props.formType == "new",
            }}
            fieldErrors={fieldErrors}
            onChange={this.handlerChangeField}
          />
          <DigiFormItem
            key="pool_id"
            formFieldKey="pool_id"
            formField={{
              type: "select",
              label: "Pool",
              required: false,
              value: this.state.selectedPool.id || this.props.poolId,
              select_options:
                this.props.locationsWithPools[
                  this.state.selectedLocation.id || this.props.locationId
                ].pools,
              enabled: this.props.formType == "new",
            }}
            fieldErrors={fieldErrors}
            onChange={this.handlerChangeField}
          />
          {Object.keys(formFields).map((formField, index) =>
            formField == "answers" ? (
              <DigiFormItem
                key={index}
                formFieldKey={formField}
                formField={{
                  type: "custom_fields_answers",
                  customFields: this.state.selectedPool.custom_fields,
                  customFieldsAnswers: formFields[formField].value || {},
                  fieldTypes: this.props.fieldTypes,
                  required: false,
                  enabled: true,
                }}
                fieldErrors={fieldErrors}
                onChange={this.handlerChangeField}
              />
            ) : (
              <DigiFormItem
                key={index}
                formFieldKey={formField}
                formField={formFields[formField]}
                fieldErrors={fieldErrors}
                stateEnabled={
                  formFields[formField].useStateToggle
                    ? this.state.selectedPool[`${formField}_toggle`]
                    : formFields[formField].toggle
                }
                onChange={this.handlerChangeField}
              />
            )
          )}

          <button
            className={classnames("btn btn-block btn-pink", {
              disabled: false,
            })}
            type="submit"
            onClick={() => this.setState({ submitAnother: false })}
          >
            SAVE
          </button>
          <button
            className={classnames("btn btn-block btn-pink", {
              disabled: false,
            })}
            onClick={() => this.setState({ submitAnother: true })}
          >
            SAVE AND SUBMIT ANOTHER
          </button>
        </form>
      </div>
    );
  }

  selectOptions = (selectObjects, titleField) => {
    return Object.values(selectObjects).map((selectObject) => [
      selectObject[titleField],
      selectObject.id,
    ]);
  };

  handlerChangeField = (newValue, key) => {
    const formFields = this.state.formFields;
    !(key in formFields) && (formFields[key] = {});
    formFields[key].value = newValue;

    this.setState({ formFields: formFields, fieldErrors: {} });

    if (key == "location_id" && newValue != "--") {
      const newPool = Object.values(
        this.props.locationsWithPools[newValue].pools
      )[0];
      formFields["pool_id"] = { value: newPool.id };
      this.setState({
        selectedLocation: this.props.locationsWithPools[newValue],
        selectedPool: newPool,
        formFields: formFields,
      });
    }

    if (key == "pool_id" && newValue != "--") {
      this.setState({
        selectedPool: this.state.selectedLocation.pools[newValue],
      });
    }
  };

  processRailsErrors = (errorFields) => {
    const fieldErrors = this.state.fieldErrors;
    Object.keys(errorFields).forEach((errorFieldKey) => {
      fieldErrors[errorFieldKey] = errorFields[errorFieldKey];
    });
    this.setState({ fieldErrors: fieldErrors });
  };

  buildDataForm = () => {
    const data = new FormData();

    Object.keys(this.state.formFields).forEach((key) => {
      let value = this.state.formFields[key].value;

      if (key == "answers") {
        Object.keys(value).forEach((answerKey) => {
          data.append(
            `${this.props.formName}[${key}][${answerKey}]`,
            value[answerKey]
          );
        });
      } else if (Array.isArray(value)) {
        value.forEach((nestedFields) => {
          Object.keys(nestedFields).forEach((nestedKey) => {
            data.append(
              `${this.props.formName}[${key}][${nestedFields.id}][${nestedKey}]`,
              nestedFields[nestedKey]
            );
          });
        });
      } else {
        data.append(`${this.props.formName}[${key}]`, value);
      }
    });

    return data;
  };

  submit = (e) => {
    e.preventDefault();
    if (!navigator.onLine) {
      toastr.info("You are offline. Please reconnect and try again.");
    }
    let that = this;

    if (this.state.loading) {
      return;
    }

    const data = this.buildDataForm();

    this.setState({ loading: true });

    const request =
      this.props.formType == "edit"
        ? axios.put(this.props.formUrl, data)
        : axios.post(this.props.formUrl, data);

    request
      .then((request) => {
        toastr.success(
          this.props.formType == "edit"
            ? "Chemical Record Updated"
            : "Chemical Record Created"
        );
        this.setState({ done: true, loading: false });

        const redirectLocation =
          this.state.submitAnother == true
            ? `/chemical_records/new?location_id=${this.state.selectedLocation.id}&pool_id=${this.state.selectedPool.id}`
            : "/chemical_records/";

        setTimeout(() => {
          window.location.href = redirectLocation;
        }, 700);
      })
      .catch(function (error) {
        if (navigator.onLine) {
          toastr.error("There is an error, please check");
          that.processRailsErrors(error.response.data);
        }
        that.setState({ loading: false, done: false });
      });
  };
}

ChemicalRecordForm.propTypes = {
  formType: PropTypes.string,
  formName: PropTypes.string,
  formUrl: PropTypes.string,
  formFields: PropTypes.object,
};

export default ChemicalRecordForm;
